import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsx as l, jsxs as d } from "react/jsx-runtime";
import { a as r } from "../strings-CHELOtPc.js";
import { c as a } from "../clsx-OuTLNxxd.js";
const m = "SectionTitle-module_section-title__eZfLN",
  _ = "SectionTitle-module_text-color-white__CC4aG",
  T = "SectionTitle-module_heading__5Ug-k",
  u = "SectionTitle-module_tagline__nrWsx",
  g = "SectionTitle-module_body__lLlxW",
  h = "SectionTitle-module_variant-wide__bWyN4",
  v = "SectionTitle-module_variant-column__GvJTr",
  t = {
    sectionTitle: m,
    textColorWhite: _,
    heading: T,
    tagline: u,
    body: g,
    variantWide: h,
    variantColumn: v
  },
  C = _ref => {
    let {
        className: e = void 0,
        children: i
      } = _ref,
      o = _objectWithoutProperties(_ref, _excluded);
    return /* @__PURE__ */l("div", _objectSpread(_objectSpread({
      className: a(t.body, e)
    }, o), {}, {
      children: i
    }));
  },
  y = _ref2 => {
    let {
      children: e,
      className: i,
      tagline: o,
      priority: n = 2
    } = _ref2;
    const c = "h".concat(n),
      s = "h".concat(n + 2);
    return /* @__PURE__ */d("div", {
      className: a(t.heading, i),
      children: [r(o) && /* @__PURE__ */l(s, {
        className: t.tagline,
        children: o
      }), /* @__PURE__ */l(c, {
        children: e
      })]
    });
  },
  N = _ref3 => {
    let {
      variant: e,
      textColor: i,
      className: o,
      children: n
    } = _ref3;
    return /* @__PURE__ */l("div", {
      className: a(t.sectionTitle, o, {
        [t.variantWide]: e == "wide",
        [t.variantColumn]: e == "column",
        [t.textColorTitanium]: i == "titanium",
        [t.textColorWhite]: i == "white"
      }),
      children: n
    });
  };
export { N as SectionTitle, C as SectionTitleBody, y as SectionTitleHeading };